import { z } from "zod";

import {
  DocumentAttributeWiringSchema,
  migrateBorderCanadaAttributeWiring,
} from "~/shared/documents/schemas/document-attribute-wiring.schema";
import { DocumentDisplayUomSettingsSchema } from "~/shared/documents/schemas/document-display-uom.schema";
import { AllowTypedSignatureSettingsSchema } from "~/shared/documents/schemas/typed-signature.schema";
import { EditorSchema } from "~/utils/types/rich-text";

/** border-canada slug — org settings config stored at ORDER_DOCUMENT_CONFIG:border-canada */
export const BorderCanadaDocumentConfigObjectSchema = z
  .object({
    header: EditorSchema,
    attributeWiring: DocumentAttributeWiringSchema.transform(migrateBorderCanadaAttributeWiring),
  })
  .merge(DocumentDisplayUomSettingsSchema)
  .merge(AllowTypedSignatureSettingsSchema);

export const BorderCanadaDocumentConfigSchema = BorderCanadaDocumentConfigObjectSchema;

export type BorderCanadaDocumentConfig = z.infer<typeof BorderCanadaDocumentConfigSchema>;
